import React from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Typography, Link, List, ListItem, ListItemText } from '@mui/material';

const AdoptedPlans = () => {
  const { t } = useTranslation();

  // Group documents into pairs with their descriptions
  const documentGroups = [
    {
      descriptionKey: 'adopted_plans.cvzsap_description',
      documents: [
        {
          title: '1A. CVZSAP Adoption Document Draft.pdf',
          fileName: '1A. CVZSAP Adoption Document Draft.pdf',
        },
        {
          title: '1B. CVZSAP Fact Sheet.pdf',
          fileName: '1B. CVZSAP Fact Sheet.pdf',
        },
      ]
    },
    {
      descriptionKey: 'adopted_plans.transportation_description',
      documents: [
        {
          title: '2A. Transportation Master Plan - Adopted Plan.pdf',
          fileName: '2A. Transportation Master Plan - Adopted Plan.pdf',
        },
        {
          title: '2B. Transportation Master Plan Fact Sheet.pdf',
          fileName: '2B. Transportation Master Plan Fact Sheet.pdf',
        },
      ]
    },
    {
      descriptionKey: 'adopted_plans.greenways_description',
      documents: [
        {
          title: '3A. Greenways and Trails Master Plan Update_Adopted Plan.pdf',
          fileName: '3A. Greenways and Trails Master Plan Update_Adopted Plan.pdf',
        },
        {
          title: '3B. Greenways and Trails Master Plan Fact Sheets.pdf',
          fileName: '3B. Greenways and Trails Master Plan Fact Sheets.pdf',
        },
      ]
    },
  ];

  return (
    <Box component="main" sx={{ p: 4, maxWidth: '960px', mx: 'auto' }}>
      <Typography variant="h3" sx={{ mb: 3, textAlign: 'center' }}>
        {t('adopted_plans.title', 'Adopted Plans')}
      </Typography>

      <Typography variant="body1" sx={{ mb: 4, fontSize: '1.1rem', textAlign: 'center' }}>
        {t(
          'adopted_plans.description',
          'Below are the adopted plan files for Miami Lakes. Click any title to open or download the document.'
        )}
      </Typography>

      <Box
        sx={{
          bgcolor: '#f9f9f9',
          borderRadius: 3,
          p: 3,
          boxShadow: '0 6px 18px rgba(0,0,0,0.08)',
        }}
      >
        <List>
          {documentGroups.map((group, groupIndex) => (
            <React.Fragment key={groupIndex}>
              {/* Description for the group */}
              <ListItem sx={{ py: 1, pl: 2 }}>
                <ListItemText
                  secondary={
                    <Typography 
                      variant="body2" 
                      sx={{ 
                        color: 'text.secondary',
                        fontStyle: 'italic',
                        mb: 1,
                        pl: 1,
                        borderLeft: '3px solid',
                        borderColor: 'primary.light',
                        paddingLeft: 2
                      }}
                    >
                      {t(group.descriptionKey)}
                    </Typography>
                  }
                />
              </ListItem>
              
              {/* Documents in the group */}
              {group.documents.map((doc) => {
                const href = `${process.env.PUBLIC_URL}/documents/adopted-plans/${encodeURIComponent(doc.fileName)}`;
                return (
                  <ListItem key={doc.title} sx={{ py: 0.5, pl: 4 }}>
                    <ListItemText
                      primary={
                        <Link
                          href={href}
                          target="_blank"
                          rel="noopener noreferrer"
                          download
                          underline="hover"
                          sx={{ fontWeight: 600, color: 'primary.main' }}
                        >
                          {doc.title}
                        </Link>
                      }
                    />
                  </ListItem>
                );
              })}
            </React.Fragment>
          ))}
        </List>
      </Box>
    </Box>
  );
};

export default AdoptedPlans;